import { useAuthStore } from '../stores/authStore';

export default function DevModeIndicator() {
  const { isDevMode, user } = useAuthStore();
  if (!isDevMode) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-amber-600/90 backdrop-blur-sm px-4 py-1.5 flex items-center justify-center gap-2">
      <div className="w-2 h-2 rounded-full bg-amber-300 animate-pulse" />
      <span className="text-xs font-medium text-amber-100">
        DEV BYPASS MODE
      </span>
      <span className="text-xs text-amber-200/70">
        Role: {user?.platform_role || 'unknown'}
      </span>
    </div>
  );
}
